import { Button, styled } from "@mui/material";

// ── Paleta de intenciones ────────────────────────────────────────────────────
const PRIMARY_RED     = '#F72E41'; // "Guardar" → acción principal
const PRIMARY_HOVER   = '#D62332';
const PRIMARY_ACTIVE  = '#B81A25';
const PRIMARY_SHADOW  = 'rgba(247, 46, 65, 0.35)';

const NEUTRAL_BG      = '#f1f5f9'; // "Cancelar" → acción neutra / sin riesgo
const NEUTRAL_BORDER  = '#cbd5e1';
const NEUTRAL_TEXT    = '#475569';
const NEUTRAL_HOVER   = '#e2e8f0';
const NEUTRAL_ACTIVE  = '#cbd5e1';

const ACCENT_BLUE     = '#6DBBE6'; // "Agregar" → acción primaria de lista

// ── Botón Guardar / Confirmar (primary) ─────────────────────────────────────
export const SendButton = styled(Button)(({ theme }) => ({
  color: 'white',
  fontSize: 15,
  fontFamily: 'Arial',
  fontWeight: 600,
  padding: '10px 20px',
  borderRadius: 10,
  textTransform: 'none',
  background: PRIMARY_RED,
  boxShadow: `0px 4px 12px ${PRIMARY_SHADOW}`,
  transition: 'background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',

  '&:hover': {
    background: PRIMARY_HOVER,
    transform: 'translateY(-2px)',
    boxShadow: `0px 6px 16px ${PRIMARY_SHADOW}`,
  },
  '&:active': {
    background: PRIMARY_ACTIVE,
    transform: 'translateY(0)',
    boxShadow: `0px 2px 6px ${PRIMARY_SHADOW}`,
  },
  '&:focus': {
    outline: 'none',
    boxShadow: `0 0 0 3px rgba(247, 46, 65, 0.4)`,
  },
  '&.Mui-disabled': {
    background: '#FCA5A5',
    color: 'rgba(255,255,255,0.7)',
    boxShadow: 'none',
  },
}));

// ── Botón Cancelar / Cerrar (neutral) ────────────────────────────────────────
export const CloseButton = styled(Button)(({ theme }) => ({
  color: NEUTRAL_TEXT,
  fontSize: 15,
  fontFamily: 'Arial',
  fontWeight: 500,
  padding: '10px 20px',
  borderRadius: 10,
  textTransform: 'none',
  backgroundColor: NEUTRAL_BG,
  border: `1.5px solid ${NEUTRAL_BORDER}`,
  boxShadow: 'none',
  transition: 'background 0.2s ease, transform 0.2s ease, border-color 0.2s ease',

  '&:hover': {
    backgroundColor: NEUTRAL_HOVER,
    borderColor: '#94a3b8',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    backgroundColor: NEUTRAL_ACTIVE,
    transform: 'translateY(0)',
  },
  '&:focus': {
    outline: 'none',
    boxShadow: '0 0 0 3px rgba(148, 163, 184, 0.4)',
  },
  '&.Mui-disabled': {
    backgroundColor: NEUTRAL_BG,
    color: '#94a3b8',
    borderColor: '#e2e8f0',
  },
}));

// ── Botón Agregar de listas (primary blue) ────────────────────────────────────
export const AddButtonStyled = styled("div")(({ theme }) => ({
  width: 'auto',
  height: 42,
  padding: '0 20px',
  background: ACCENT_BLUE,
  boxShadow: "0px 0px 6px rgba(255, 255, 255, 0.05) inset",
  borderRadius: 30,
  border: "0.50px rgba(255, 255, 255, 0.70) solid",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 4,
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#fff',
  transition: 'background 0.3s ease, transform 0.3s ease',
  '&:hover': {
    cursor: "pointer",
    background: "#5A9FD4",
    transform: 'scale(1.05)',
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
  '&:focus': {
    outline: 'none',
    boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.5)',
  },
}));

export const AddButtonStyledText = styled("div")(({ theme }) => ({
  color: "white",
  fontSize: 12,
  fontFamily: "Arial",
  fontWeight: 400,
  wordWrap: "break-word",
}));